import {BASE_URL} from 'appConstants';

import {get} from 'sdk';

export const fetchWebhooks = () => {
  const url = `${BASE_URL}/v1/webhooks/`;

  return get(url);
};

export const fetchSchedulerRunsChartData = ({offset, resolution}) => {
  const url = `${BASE_URL}/v1/webhooks/charts/scheduler-runs/`;

  const params = {offset, resolution};

  return get(url, params);
};
